import React from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";

import "./style.scss";
import { Label } from "../../../../library/label";

const Index = () => {
  const employeesFrom = useSelector(
    (state) => state.newList.listFilter.employeesFrom
  );
  const employeesTo = useSelector(
    (state) => state.newList.listFilter.employeesTo
  );
  const registrationFrom = useSelector(
    (state) => state.newList.listFilter.registrationFrom
  );
  const registrationTo = useSelector(
    (state) => state.newList.listFilter.registrationTo
  );
  const organizationType = useSelector(
    (state) => state.newList.listFilter.organizationType
  );
  const vatRegistered = useSelector(
    (state) => state.newList.listFilter.isVatRegistered
  );
  const inBusinessRegister = useSelector(
    (state) => state.newList.listFilter.inBusinessRegister
  );
  const inFoundationRegister = useSelector(
    (state) => state.newList.listFilter.inFoundationRegister
  );
  const inVolunteerRegister = useSelector(
    (state) => state.newList.listFilter.inVolunteerRegister
  );

  const listReach = useSelector((state) => state.newList.listSize.status);
  const reachLoading = useSelector((state) => state.newList.listSize.loading);

  const returnStatus = (status) => {
    if (status === "true") {
      return "Ja";
    } else {
      return "Nei";
    }
  };

  return (
    <div className="new-list-statistics-container">
      <Row className="single-result-row row">
        <Col className="result-col text-left">
          <Label version={3} weight="bold">
            Antall bedrifter
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={3} weight="bold">
            {reachLoading && <i className="fas fa-circle-notch fa-spin"></i>}
            <NumberFormat
              value={!reachLoading && listReach}
              displayType={"text"}
              thousandSeparator={" "}
            />
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Antall ansatte fra
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {employeesFrom ? employeesFrom : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Antall ansatte til
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {employeesTo ? employeesTo : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Registreringsdato fra
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {registrationFrom ? registrationFrom : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Registreringsdato til
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {registrationTo ? registrationTo : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Organisasjonsform
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {organizationType
              ? returnStatus(organizationType)
              : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Registrert i MVA-registeret
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {vatRegistered ? returnStatus(vatRegistered) : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Registrert i Foretaksregisteret
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {inBusinessRegister
              ? returnStatus(inBusinessRegister)
              : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Registrert i Stiftelsesregisteret
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {inFoundationRegister
              ? returnStatus(inFoundationRegister)
              : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
      <Row className="single-result-row">
        <Col className="result-col text-left">
          <Label version={2} weight="bold">
            Registrert i Frivillighetsregisteret
          </Label>
        </Col>
        <Col className="result-col text-right">
          <Label version={1} weight="bold">
            {inVolunteerRegister
              ? returnStatus(inVolunteerRegister)
              : "Ikke spesifisert"}
          </Label>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
